module.exports = __webpack_public_path__ + "files/32c4117beea594fc5398b79bbd81c336.png";